<template>
    <div class="cookies-consent p-2 p-sm-2 p-md-4" v-if="!cookieSet">
        <div class="description">
            <span
                >Šajā lapā tiek izmantotas sīkdatnes. Nospiežot pogu "Piekrītu",
                jūs atļaujat to izmantošanu.
                <b-link :to="'/par-sikdatnem'" class="link-to-cookies-policy"
                    >Uzzināt vairāk.</b-link
                >
            </span>
        </div>
        <div class="confirm-button">
            <b-button @click="confirm()" class="accept-cookies pl-5 pr-5"
                >Piekrītu</b-button
            >
        </div>
    </div>
</template>

<script>
export default {
    name: "cookiesConsent",
    data: () => ({
        cookieSet: false,
    }),
    methods: {
        checkIfCookiesAccepted() {
            const storedConsentCookie = this.$cookies.get(
                "vietvardi_cookies_consent_status"
            );

            this.cookieSet = !!storedConsentCookie;
        },
        confirm() {
            this.$cookies.set("vietvardi_cookies_consent_status", true, "365d");
            this.cookieSet = true;
        },
    },
    mounted() {
        this.checkIfCookiesAccepted();
    },
};
</script>

<style lang="scss" scoped>
@import "~@/_variables.scss";

.cookies-consent {
    width: 100%;
    position: fixed;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    text-align: center;

    span {
        color: $white;
        font-size: 24px;
    }

    .link-to-cookies-policy {
        color: $white;
    }
}

.accept-cookies {
    background-image: linear-gradient($gradient-yellow, $gradient-red);
}

@media (max-width: $xs-media) {
    .cookies-consent {
        span {
            color: $white;
            font-size: 12px;
        }
    }
}
</style>
